/*
 * Cadeau offert (GWP) — contrôleur UI du drawer panier.
 *
 * Rôle : afficher la progression vers le seuil, proposer/ajouter/retirer le cadeau.
 * La GRATUITÉ n'est PAS gérée ici : c'est la Shopify Function « gwp-discount »
 * qui remise la ligne cadeau à 100% côté serveur si le panier qualifie (≥ seuil).
 * Ce JS marque juste la ligne via la property `_gwp:true` et gère l'UX.
 *
 * Mode AJOUT AUTOMATIQUE (sept. 2026, Bubble Mask Bio-Detox) : dès que le panier
 * atteint le seuil, le cadeau est ajouté seul. Si la cliente le retire, on ne le
 * remet pas dans la session (sessionStorage), il revient à la visite suivante.
 * En rupture (422 sur /cart/add.js) on arrête d'essayer et on masque le bloc.
 *
 * Angles couverts : seuil avant codes (original_line_price), auto-retrait debounce
 * + flag anti-boucle, swap sans doublon, rupture, 1 seul cadeau, panier persistant
 * au load, analytics.
 */
(function () {
  var root = document.querySelector('[data-gwp]');
  var configEl = document.querySelector('[data-gwp-config]');
  if (!root || !configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var THRESHOLD_CENTS = Math.round((parseFloat(config.threshold) || 90) * 100);
  var STRINGS = config.strings || {};
  // Allowlist des variantes cadeaux (validation côté client ; la function revalide).
  var ALLOWED = new Set();
  (config.gifts || []).forEach(function (g) {
    (g.variant_ids || []).forEach(function (id) { ALLOWED.add(String(id)); });
  });

  var msgEl = root.querySelector('[data-gwp-msg]');
  var barEl = root.querySelector('[data-gwp-bar]');
  var fillEl = root.querySelector('[data-gwp-fill]');
  var pickerEl = root.querySelector('[data-gwp-picker]');

  var mutating = false;     // true pendant une mutation panier → casse la boucle cart:change
  var debounceTimer = null;
  var soldOut = false;      // 422 reçu à l'ajout → cadeau épuisé, on n'insiste plus
  var lastHadGift = null;   // état précédent (null = inconnu) pour détecter un retrait manuel
  var DECLINED_KEY = 'tkp_gwp_declined';

  function isDeclined() {
    try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; }
  }
  function setDeclined(v) {
    try { v ? sessionStorage.setItem(DECLINED_KEY, '1') : sessionStorage.removeItem(DECLINED_KEY); } catch (e) {}
  }

  // Variante à ajouter automatiquement : 1re variante du 1er cadeau disponible.
  function autoVariantId() {
    var gifts = config.gifts || [];
    for (var i = 0; i < gifts.length; i++) {
      if (gifts[i].available === false) continue;
      var ids = gifts[i].variant_ids || [];
      if (ids.length) return String(ids[0]);
    }
    return null;
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Sous-total des produits ÉLIGIBLES (hors cartes cadeaux et hors ligne cadeau),
  // AVANT codes promo → on utilise original_line_price (déjà en centimes).
  function eligibleSubtotalCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.gift_card) return;
      if (item.properties && item.properties._gwp === 'true') return;
      total += item.original_line_price;
    });
    return total;
  }

  function findGiftItem(cart) {
    return (cart.items || []).find(function (item) {
      return item.properties && item.properties._gwp === 'true';
    }) || null;
  }

  function track(name, variantId) {
    document.dispatchEvent(new CustomEvent('gwp:' + name, {
      detail: { variantId: variantId }, bubbles: true
    }));
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'gwp_' + name, gwp_variant_id: variantId });
    }
  }

  function setProgress(eligible) {
    var pct = Math.max(0, Math.min(100, Math.round((eligible / THRESHOLD_CENTS) * 100)));
    if (fillEl) fillEl.style.width = pct + '%';
    if (barEl) barEl.setAttribute('aria-valuenow', String(pct));
  }

  function render(cart) {
    var itemCount = cart.item_count || 0;
    if (itemCount === 0 || soldOut) { root.hidden = true; return; }
    root.hidden = false;

    var eligible = eligibleSubtotalCents(cart);
    var gift = findGiftItem(cart);
    setProgress(eligible);

    if (gift) {
      // État (c) : cadeau au panier.
      if (msgEl) msgEl.innerHTML = STRINGS.added || 'Cadeau offert ajouté';
      if (pickerEl) pickerEl.hidden = true;
    } else if (eligible >= THRESHOLD_CENTS) {
      // État (b) : seuil atteint, pas encore de cadeau.
      // Ajout automatique en cours (message d'attente) ; si la cliente l'a retiré
      // dans cette session, on lui laisse le sélecteur pour le remettre.
      if (isDeclined()) {
        if (msgEl) msgEl.innerHTML = STRINGS.choose || 'Votre cadeau offert vous attend';
        if (pickerEl) pickerEl.hidden = false;
      } else {
        if (msgEl) msgEl.innerHTML = STRINGS.adding || 'Ajout de votre cadeau offert…';
        if (pickerEl) pickerEl.hidden = true;
      }
    } else {
      // État (a) : sous le seuil.
      var remaining = THRESHOLD_CENTS - eligible;
      var tpl = STRINGS.remaining_html || 'Plus que __AMOUNT__ pour votre cadeau';
      if (msgEl) msgEl.innerHTML = tpl.replace('__AMOUNT__', money(remaining));
      if (pickerEl) pickerEl.hidden = true;
    }
  }

  // ---- Cart API helpers ----
  function getCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function notifyThemeChange(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  }

  // Ajoute (ou swap) le cadeau. variantId déjà validé contre l'allowlist.
  function addGift(variantId, existingGift) {
    if (mutating) return;
    mutating = true;

    var doAdd = function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, properties: { _gwp: 'true' } })
      }).then(function (r) {
        if (!r.ok) {
          // 422 = rupture de stock (ou variante indisponible) → on n'insiste plus.
          soldOut = true;
          track('gift_unavailable', variantId);
          throw new Error('gwp add failed ' + r.status);
        }
        return r;
      });
    };

    var chain;
    if (existingGift) {
      // Swap : retirer l'ancien cadeau d'abord (pas de doublon), puis ajouter.
      chain = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: existingGift.key, quantity: 0 })
      }).then(doAdd);
    } else {
      chain = doAdd();
    }

    chain
      .then(getCart)
      .then(function (cart) {
        track(existingGift ? 'gift_swapped' : 'gift_added', variantId);
        setDeclined(false);
        lastHadGift = true;
        mutating = false;
        notifyThemeChange(cart);
        render(cart);
      })
      .catch(function () {
        mutating = false;
        if (soldOut) render({ item_count: 0 });
      });
  }

  function removeGift(gift) {
    if (mutating) return;
    mutating = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: gift.key, quantity: 0 })
    })
      .then(getCart)
      .then(function (cart) {
        track('gift_removed', gift.variant_id);
        lastHadGift = false;
        mutating = false;
        notifyThemeChange(cart);
        render(cart);
      })
      .catch(function () { mutating = false; });
  }

  // Boucle principale : décide auto-retrait sinon rend.
  function refresh(cart) {
    var run = function (c) {
      if (typeof c.currency === 'string' && config.currency && c.currency !== config.currency) {
        // Mono-marché EUR aujourd'hui : on signale mais on continue.
        // (Si un jour multi-devise, scoper le seuil par devise.)
        try { console.warn('[gwp] devise panier', c.currency, '≠', config.currency); } catch (e) {}
      }
      var eligible = eligibleSubtotalCents(c);
      var gift = findGiftItem(c);

      // Panier vidé → on oublie le refus de la session.
      if ((c.item_count || 0) === 0) { setDeclined(false); lastHadGift = null; render(c); return; }

      // Retrait manuel : le cadeau était là, il n'y est plus, et le panier qualifie toujours
      // (sinon c'est notre auto-retrait) → ne pas le remettre pendant cette session.
      if (lastHadGift === true && !gift && eligible >= THRESHOLD_CENTS && !mutating) {
        setDeclined(true);
      }
      lastHadGift = !!gift;

      // Auto-retrait : panier repassé sous le seuil avec un cadeau présent.
      if (gift && eligible < THRESHOLD_CENTS && !mutating) {
        removeGift(gift);
        return;
      }
      // Ajout automatique : seuil atteint, pas de cadeau, pas refusé, pas épuisé.
      if (!gift && eligible >= THRESHOLD_CENTS && !mutating && !soldOut && !isDeclined()) {
        var vid = autoVariantId();
        if (vid && ALLOWED.has(vid)) {
          render(c);          // affiche « Ajout de votre cadeau… » pendant la requête
          addGift(vid, null);
          return;
        }
      }
      render(c);
    };
    if (cart) { run(cart); }
    else { getCart().then(run); }
  }

  // ---- Événements ----
  // Délégation sur le sélecteur (boutons "Ajouter ce cadeau").
  if (pickerEl) {
    pickerEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gwp-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        var select = btn.parentNode.querySelector('[data-gwp-variant]');
        if (select) variantId = select.value;
      }
      if (!variantId || !ALLOWED.has(String(variantId))) return;
      // Empêche un 2e cadeau : si déjà un cadeau, on swap.
      getCart().then(function (cart) {
        addGift(variantId, findGiftItem(cart));
      });
    });
  }

  // Re-render à chaque changement de panier (debounce anti-boucle).
  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail ? e.detail.cart : null;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { refresh(cart); }, 350);
  });

  // Au chargement : gère le panier persistant déjà ≥ seuil (proposition immédiate).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); });
  } else {
    refresh();
  }
})();
